export default __webpack_public_path__ + "static/media/React_logo.64ee26cd.jpg";